import React, { createContext, useState, useCallback } from 'react';
import { useMutation, useLazyQuery } from '@apollo/client';
import { CREATE_LAW_REPORT, MODIFY_LAW_REPORT } from 'schema/Case';
import notify from 'utils/toast';
import { GET_SUBJECT_MATTER } from 'schema/SubjectMatter';
import { GET_HEADNOTES } from 'schema/headnotes';
import { GET_CASES } from 'schema/Case';
export const CaseContext = createContext({});

export default ({ children }) => {
    const [getCaseToEdit, { data: caseToEdit }] = useLazyQuery(GET_CASES);
    const [
        getSubjectMatterToEdit,
        { data: subjectMatterToEdit },
    ] = useLazyQuery(GET_SUBJECT_MATTER);
    const [getHeadnotesToEdit, { data: HeadnotesToEdit }] = useLazyQuery(
        GET_HEADNOTES
    );
    const [name, SetName] = useState('');
    const [date, setDate] = useState('');
    const [singleCase, setSingleCase] = useState({
        case_history: '',
        case_no: '',
        casejudgment: '',
        cases_reference: '',
        court_id: 0,
        date_of_judgement: '',
        facts_and_history: '',
        held: '',
        issues: '',
        party_1: '',
        party_1_desc: '',
        party_2: '',
        party_2_desc: '',
        party_1_title: '',
        party_2_title: '',
        volume: '',
        subject_matter: [
            {
                subject_matter_heading: '',
                description: '',
            },
        ],
        head_notes: [
            {
                heading: '',
                ratio_decidendi: {
                    link_per: '',
                    summary: '',
                    judgement: {
                        judgement_type: 0,
                        justice_id: 0,
                    },
                },
            },
        ],
    });
    const [editedCase, setEditedCase] = useState();
    const [editedSubjectMatter, setEditedSubjectMatter] = useState();
    const [editedHeadnotes, setEditedHeadnotes] = useState();
    const [sendCase, { data }] = useMutation(CREATE_LAW_REPORT);
    const [updateCase, { data: updateData }] = useMutation(MODIFY_LAW_REPORT);
    const [mainJudgementJustice, setMainJudgementJustice] = useState();

    const getCaseForEditing = useCallback((id) => {
        getCaseToEdit({
            variables: {
                options: {
                    byId: id,
                },
                region: 'ng',
                type: 'cases',
            },
        });
    }, []);

    const getSubjectMatterForEditing = useCallback((options) => {
        getSubjectMatterToEdit({
            variables: {
                options,
                region: 'ng',
                type: 'subject_matter',
            },
        });
    }, []);

    const getHeadnoteForEditing = useCallback((id) => {
        getHeadnotesToEdit({
            variables: {
                options: {
                    take: 20,
                    skip: 0,
                    where: [
                        {
                            key: 'case_id',
                            value: id,
                        },
                    ],
                },
                region: 'ng',
                type: 'head_notes',
            },
        });
    }, []);

    React.useEffect(() => {
        if (caseToEdit) {
            if (caseToEdit.error) {
                console.log(caseToEdit.error);
            } else {
                setEditedCase(caseToEdit?.lp_read?.data?.cases[0]);
            }
        }
    }, [caseToEdit]);

    React.useEffect(() => {
        if (subjectMatterToEdit) {
            if (subjectMatterToEdit.error) {
                console.log(subjectMatterToEdit.error);
            } else {
                setEditedSubjectMatter({
                    subject_matter:
                        subjectMatterToEdit?.lp_read?.data?.subject_matter,
                });
            }
        }
    }, [subjectMatterToEdit]);

    React.useEffect(() => {
        if (HeadnotesToEdit) {
            if (HeadnotesToEdit.error) {
                console.log(HeadnotesToEdit.error);
            } else {
                setEditedHeadnotes(HeadnotesToEdit?.lp_read?.data?.head_notes);
            }
        }
    }, [HeadnotesToEdit]);

    const submitCase = () => {
        sendCase({
            variables: {
                data: {
                    case: {
                        ...singleCase,
                    },
                },
                region: 'ng',
            },
        })
            .then(() => {
                setSingleCase({
                    case_history: '',
                    case_no: '',
                    casejudgment: '',
                    cases_reference: '',
                    court_id: 0,
                    date_of_judgement: '',
                    facts_and_history: '',
                    held: '',
                    issues: '',
                    party_1: '',
                    party_1_desc: '',
                    party_2: '',
                    party_2_desc: '',
                    party_1_title: '',
                    party_2_title: '',
                    volume: '',
                    subject_matter: [
                        {
                            subject_matter_heading: '',
                            description: '',
                        },
                    ],
                    head_notes: [
                        {
                            heading: '',
                            ratio_decidendi: {
                                link_per: '',
                                summary: '',
                                judgement: {
                                    judgement_type: 0,
                                    justice_id: 0,
                                },
                            },
                        },
                    ],
                });
                SetName('');
                setDate('');
                notify('Successfully Created', 'success');
                setTimeout(function () {
                    window.location.reload(false);
                }, 5000);
            })
            .catch(() => notify('An error occurred', 'error'));
    };

    const updateThisCase = (volume, caseId) => {
        const {
            party_1_title,
            party_2_title,
            case_no,
            party_1,
            party_2,
            party_1_desc,
            party_2_desc,
            court_id,
            date_of_judgement,
            facts_and_history,
            issues,
            held,
            casejudgment,
            cases_reference,
            case_history,
        } = editedCase;
        updateCase({
            variables: {
                data: [
                    {
                        case_id: caseId,
                        party_1_title,
                        party_2_title,
                        case_no,
                        volume,
                        party_1,
                        party_2,
                        party_1_desc,
                        party_2_desc,
                        court_id,
                        date_of_judgement,
                        facts_and_history,
                        issues,
                        held,
                        //casejudgment,
                        cases_reference,
                        case_history,
                    },
                ],
                type: 'cases',
                region: 'ng',
            },
        })
            .then(() => {
                // SetName('');
                // setDate('');
                notify('Successfully Updated', 'success');

                setTimeout(function () {
                    window.location.reload(false);
                }, 5000);
            })
            .catch(() => notify('An error occurred', 'error'));
    };

    return (
        <CaseContext.Provider
            value={{
                singleCase,
                editedCase,
                editedSubjectMatter,
                editedHeadnotes,
                data,
                submitCase,
                updateThisCase,
                setSingleCase,
                setEditedCase,
                setEditedSubjectMatter,
                setEditedHeadnotes,
                getSubjectMatterForEditing,
                getHeadnoteForEditing,
                name,
                SetName,
                date,
                setDate,
                getCaseForEditing,
                mainJudgementJustice,
                setMainJudgementJustice,
            }}
        >
            {children}
        </CaseContext.Provider>
    );
};
